import { defineMessages } from '../../i18n/index.ts'

export const wheelMessages = defineMessages({
	en: {
		short: 'Name wheel',
		title: 'Name wheel and groups',
		tabWheel: 'Wheel',
		tabGroups: 'Groups',
		list: 'Class list',
		listName: 'List name',
		listNameHint: 'For example 7B',
		untitled: (n: number) => `List ${n}`,
		newList: 'New list',
		deleteList: 'Delete list',
		names: 'Names, one per line',
		count: (n: number) => (n === 1 ? '1 name' : `${n} names`),
		useResults: 'Use names from my results',
		allResults: 'All my results',
		noResults: 'No handed-in results yet, so there are no names to take.',
		loadFailed: 'Could not load the names',
		needNames: 'Add at least two names to spin the wheel.',
		spin: 'Spin',
		spinHint: 'or press the space bar',
		fullscreen: 'Full screen',
		exitFullscreen: 'Exit full screen',
		removePicked: 'Take picked names off until everyone has had a turn',
		everyone: 'Everyone has had a turn',
		startOver: 'Start over',
		wheelLabel: 'Name wheel',
		pickedName: 'Picked',
		groupsBy: 'Split by',
		byCount: 'Number of groups',
		bySize: 'Students per group',
		reshuffle: 'Shuffle again',
		print: 'Print',
		group: (n: number) => `Group ${n}`,
		allTools: 'All tools',
		sound: 'Tick sound',
		addNames: 'Add names',
		less: 'Fewer',
		more: 'More',
		done: 'Done',
		takeNames: 'Take names',
	},
	ro: {
		short: 'Roata numelor',
		title: 'Roata numelor și grupe',
		tabWheel: 'Roata',
		tabGroups: 'Grupe',
		list: 'Lista clasei',
		listName: 'Numele listei',
		listNameHint: 'De exemplu 7B',
		untitled: (n: number) => `Lista ${n}`,
		newList: 'Listă nouă',
		deleteList: 'Șterge lista',
		names: 'Nume, câte unul pe rând',
		count: (n: number) => (n === 1 ? '1 nume' : `${n} nume`),
		useResults: 'Folosește numele din rezultatele mele',
		allResults: 'Toate rezultatele mele',
		noResults: 'Nu există încă rezultate trimise, deci nu sunt nume de preluat.',
		loadFailed: 'Nu am putut încărca numele',
		needNames: 'Adaugă cel puțin două nume ca să învârți roata.',
		spin: 'Învârte',
		spinHint: 'sau apasă bara de spațiu',
		fullscreen: 'Ecran complet',
		exitFullscreen: 'Ieși din ecran complet',
		removePicked: 'Scoate numele alese până au venit toți la rând',
		everyone: 'Au venit la rând toți',
		startOver: 'De la capăt',
		wheelLabel: 'Roata numelor',
		pickedName: 'Ales',
		groupsBy: 'Împarte după',
		byCount: 'Număr de grupe',
		bySize: 'Elevi într-o grupă',
		reshuffle: 'Amestecă din nou',
		print: 'Tipărește',
		group: (n: number) => `Grupa ${n}`,
		allTools: 'Toate instrumentele',
		sound: 'Sunet la rotire',
		addNames: 'Adaugă nume',
		less: 'Mai puțin',
		more: 'Mai mult',
		done: 'Gata',
		takeNames: 'Preia numele',
	},
	ru: {
		short: 'Колесо имён',
		title: 'Колесо имён и группы',
		tabWheel: 'Колесо',
		tabGroups: 'Группы',
		list: 'Список класса',
		listName: 'Название списка',
		listNameHint: 'Например, 7Б',
		untitled: (n: number) => `Список ${n}`,
		newList: 'Новый список',
		deleteList: 'Удалить список',
		names: 'Имена, по одному в строке',
		count: (n: number) => `Имён: ${n}`,
		useResults: 'Взять имена из моих результатов',
		allResults: 'Все мои результаты',
		noResults: 'Пока нет сданных работ, поэтому брать имена неоткуда.',
		loadFailed: 'Не удалось загрузить имена',
		needNames: 'Добавьте хотя бы два имени, чтобы крутить колесо.',
		spin: 'Крутить',
		spinHint: 'или нажмите пробел',
		fullscreen: 'На весь экран',
		exitFullscreen: 'Выйти из полного экрана',
		removePicked: 'Убирать выбранных, пока не отвечут все',
		everyone: 'Все уже отвечали',
		startOver: 'Начать заново',
		wheelLabel: 'Колесо имён',
		pickedName: 'Выпало',
		groupsBy: 'Делить по',
		byCount: 'Число групп',
		bySize: 'Учеников в группе',
		reshuffle: 'Перемешать снова',
		print: 'Печать',
		group: (n: number) => `Группа ${n}`,
		allTools: 'Все инструменты',
		sound: 'Звук щелчков',
		addNames: 'Добавить имена',
		less: 'Меньше',
		more: 'Больше',
		done: 'Готово',
		takeNames: 'Взять имена',
	},
	fr: {
		short: 'Roue des prénoms',
		title: 'Roue des prénoms et groupes',
		tabWheel: 'Roue',
		tabGroups: 'Groupes',
		list: 'Liste de la classe',
		listName: 'Nom de la liste',
		listNameHint: 'Par exemple 7B',
		untitled: (n: number) => `Liste ${n}`,
		newList: 'Nouvelle liste',
		deleteList: 'Supprimer la liste',
		names: 'Prénoms, un par ligne',
		count: (n: number) => (n <= 1 ? `${n} prénom` : `${n} prénoms`),
		useResults: 'Prendre les prénoms de mes résultats',
		allResults: 'Tous mes résultats',
		noResults: 'Aucun résultat rendu pour l’instant, donc aucun prénom à reprendre.',
		loadFailed: 'Impossible de charger les prénoms',
		needNames: 'Ajoutez au moins deux prénoms pour lancer la roue.',
		spin: 'Lancer',
		spinHint: 'ou appuyez sur la barre d’espace',
		fullscreen: 'Plein écran',
		exitFullscreen: 'Quitter le plein écran',
		removePicked: 'Retirer les prénoms tirés jusqu’à ce que tout le monde soit passé',
		everyone: 'Tout le monde est passé',
		startOver: 'Recommencer',
		wheelLabel: 'Roue des prénoms',
		pickedName: 'Tiré',
		groupsBy: 'Répartir par',
		byCount: 'Nombre de groupes',
		bySize: 'Élèves par groupe',
		reshuffle: 'Mélanger à nouveau',
		print: 'Imprimer',
		group: (n: number) => `Groupe ${n}`,
		allTools: 'Tous les outils',
		sound: 'Son du cliquet',
		addNames: 'Ajouter des noms',
		less: 'Moins',
		more: 'Plus',
		done: 'Terminé',
		takeNames: 'Prendre les noms',
	},
	it: {
		short: 'Ruota dei nomi',
		title: 'Ruota dei nomi e gruppi',
		tabWheel: 'Ruota',
		tabGroups: 'Gruppi',
		list: 'Elenco della classe',
		listName: 'Nome dell’elenco',
		listNameHint: 'Per esempio 7B',
		untitled: (n: number) => `Elenco ${n}`,
		newList: 'Nuovo elenco',
		deleteList: 'Elimina elenco',
		names: 'Nomi, uno per riga',
		count: (n: number) => (n === 1 ? '1 nome' : `${n} nomi`),
		useResults: 'Usa i nomi dei miei risultati',
		allResults: 'Tutti i miei risultati',
		noResults: 'Nessun risultato consegnato finora, quindi non ci sono nomi da prendere.',
		loadFailed: 'Impossibile caricare i nomi',
		needNames: 'Aggiungi almeno due nomi per far girare la ruota.',
		spin: 'Gira',
		spinHint: 'oppure premi la barra spaziatrice',
		fullscreen: 'Schermo intero',
		exitFullscreen: 'Esci da schermo intero',
		removePicked: 'Togli i nomi estratti finché non hanno risposto tutti',
		everyone: 'Hanno risposto tutti',
		startOver: 'Ricomincia',
		wheelLabel: 'Ruota dei nomi',
		pickedName: 'Estratto',
		groupsBy: 'Dividi per',
		byCount: 'Numero di gruppi',
		bySize: 'Studenti per gruppo',
		reshuffle: 'Rimescola',
		print: 'Stampa',
		group: (n: number) => `Gruppo ${n}`,
		allTools: 'Tutti gli strumenti',
		sound: 'Suono dei clic',
		addNames: 'Aggiungi nomi',
		less: 'Meno',
		more: 'Più',
		done: 'Fatto',
		takeNames: 'Prendi i nomi',
	},
	kk: {
		short: 'Есім дөңгелегі',
		title: 'Есім дөңгелегі және топтар',
		tabWheel: 'Дөңгелек',
		tabGroups: 'Топтар',
		list: 'Сынып тізімі',
		listName: 'Тізім атауы',
		listNameHint: 'Мысалы, 7Б',
		untitled: (n: number) => `Тізім ${n}`,
		newList: 'Жаңа тізім',
		deleteList: 'Тізімді жою',
		names: 'Есімдер, әр жолға біреуден',
		count: (n: number) => `Есім: ${n}`,
		useResults: 'Нәтижелерімнен есімдерді алу',
		allResults: 'Барлық нәтижелерім',
		noResults: 'Әзірге тапсырылған жұмыс жоқ, сондықтан алынатын есім жоқ.',
		loadFailed: 'Есімдерді жүктеу мүмкін болмады',
		needNames: 'Дөңгелекті айналдыру үшін кемінде екі есім қосыңыз.',
		spin: 'Айналдыру',
		spinHint: 'немесе бос орын пернесін басыңыз',
		fullscreen: 'Толық экран',
		exitFullscreen: 'Толық экраннан шығу',
		removePicked: 'Барлығы жауап бергенше таңдалғандарды алып тастау',
		everyone: 'Барлығы жауап берді',
		startOver: 'Басынан бастау',
		wheelLabel: 'Есім дөңгелегі',
		pickedName: 'Түскені',
		groupsBy: 'Бөлу тәсілі',
		byCount: 'Топ саны',
		bySize: 'Топтағы оқушы саны',
		reshuffle: 'Қайта араластыру',
		print: 'Басып шығару',
		group: (n: number) => `${n}-топ`,
		allTools: 'Барлық құралдар',
		sound: 'Шырт еткен дыбыс',
		addNames: 'Аттарды қосу',
		less: 'Азырақ',
		more: 'Көбірек',
		done: 'Дайын',
		takeNames: 'Аттарды алу',
	},
	es: {
		short: 'Ruleta de nombres',
		title: 'Ruleta de nombres y grupos',
		tabWheel: 'Ruleta',
		tabGroups: 'Grupos',
		list: 'Lista de la clase',
		listName: 'Nombre de la lista',
		listNameHint: 'Por ejemplo 7B',
		untitled: (n: number) => `Lista ${n}`,
		newList: 'Lista nueva',
		deleteList: 'Eliminar lista',
		names: 'Nombres, uno por línea',
		count: (n: number) => (n === 1 ? '1 nombre' : `${n} nombres`),
		useResults: 'Usar los nombres de mis resultados',
		allResults: 'Todos mis resultados',
		noResults: 'Aún no hay resultados entregados, así que no hay nombres que tomar.',
		loadFailed: 'No se pudieron cargar los nombres',
		needNames: 'Añade al menos dos nombres para girar la ruleta.',
		spin: 'Girar',
		spinHint: 'o pulsa la barra espaciadora',
		fullscreen: 'Pantalla completa',
		exitFullscreen: 'Salir de pantalla completa',
		removePicked: 'Quitar los nombres elegidos hasta que todos hayan tenido su turno',
		everyone: 'Todos han tenido su turno',
		startOver: 'Empezar de nuevo',
		wheelLabel: 'Ruleta de nombres',
		pickedName: 'Elegido',
		groupsBy: 'Dividir por',
		byCount: 'Número de grupos',
		bySize: 'Alumnos por grupo',
		reshuffle: 'Mezclar otra vez',
		print: 'Imprimir',
		group: (n: number) => `Grupo ${n}`,
		allTools: 'Todas las herramientas',
		sound: 'Sonido de clic',
		addNames: 'Añadir nombres',
		less: 'Menos',
		more: 'Más',
		done: 'Listo',
		takeNames: 'Tomar los nombres',
	},
	pt: {
		short: 'Roleta de nomes',
		title: 'Roleta de nomes e grupos',
		tabWheel: 'Roleta',
		tabGroups: 'Grupos',
		list: 'Lista da turma',
		listName: 'Nome da lista',
		listNameHint: 'Por exemplo 7B',
		untitled: (n: number) => `Lista ${n}`,
		newList: 'Nova lista',
		deleteList: 'Excluir lista',
		names: 'Nomes, um por linha',
		count: (n: number) => (n === 1 ? '1 nome' : `${n} nomes`),
		useResults: 'Usar os nomes dos meus resultados',
		allResults: 'Todos os meus resultados',
		noResults: 'Ainda não há resultados entregues, então não há nomes para usar.',
		loadFailed: 'Não foi possível carregar os nomes',
		needNames: 'Adicione pelo menos dois nomes para girar a roleta.',
		spin: 'Girar',
		spinHint: 'ou aperte a barra de espaço',
		fullscreen: 'Tela cheia',
		exitFullscreen: 'Sair da tela cheia',
		removePicked: 'Tirar os nomes sorteados até todos terem tido a vez',
		everyone: 'Todos já tiveram a vez',
		startOver: 'Recomeçar',
		wheelLabel: 'Roleta de nomes',
		pickedName: 'Sorteado',
		groupsBy: 'Dividir por',
		byCount: 'Número de grupos',
		bySize: 'Alunos por grupo',
		reshuffle: 'Misturar de novo',
		print: 'Imprimir',
		group: (n: number) => `Grupo ${n}`,
		allTools: 'Todas as ferramentas',
		sound: 'Som de clique',
		addNames: 'Adicionar nomes',
		less: 'Menos',
		more: 'Mais',
		done: 'Pronto',
		takeNames: 'Usar os nomes',
	},
	de: {
		short: 'Namensrad',
		title: 'Namensrad und Gruppen',
		tabWheel: 'Rad',
		tabGroups: 'Gruppen',
		list: 'Klassenliste',
		listName: 'Name der Liste',
		listNameHint: 'Zum Beispiel 7B',
		untitled: (n: number) => `Liste ${n}`,
		newList: 'Neue Liste',
		deleteList: 'Liste löschen',
		names: 'Namen, einer pro Zeile',
		count: (n: number) => (n === 1 ? '1 Name' : `${n} Namen`),
		useResults: 'Namen aus meinen Ergebnissen übernehmen',
		allResults: 'Alle meine Ergebnisse',
		noResults: 'Noch keine abgegebenen Ergebnisse, also gibt es keine Namen zu übernehmen.',
		loadFailed: 'Die Namen konnten nicht geladen werden',
		needNames: 'Füge mindestens zwei Namen hinzu, um das Rad zu drehen.',
		spin: 'Drehen',
		spinHint: 'oder Leertaste drücken',
		fullscreen: 'Vollbild',
		exitFullscreen: 'Vollbild beenden',
		removePicked: 'Gezogene Namen entfernen, bis alle dran waren',
		everyone: 'Alle waren dran',
		startOver: 'Von vorn',
		wheelLabel: 'Namensrad',
		pickedName: 'Gezogen',
		groupsBy: 'Aufteilen nach',
		byCount: 'Anzahl der Gruppen',
		bySize: 'Schüler pro Gruppe',
		reshuffle: 'Neu mischen',
		print: 'Drucken',
		group: (n: number) => `Gruppe ${n}`,
		allTools: 'Alle Werkzeuge',
		sound: 'Klickgeräusch',
		addNames: 'Namen hinzufügen',
		less: 'Weniger',
		more: 'Mehr',
		done: 'Fertig',
		takeNames: 'Namen übernehmen',
	},
})
